module.exports = __webpack_public_path__ + "img/stepper.ab5cbfe8.png";